import { useCallback } from 'react';
import { apiFetch } from '../../../config/api';
// Migrated to MV endpoint - use useTemplatesForExperiments instead
import { useTemplatesForExperiments } from './useTemplatesForExperiments';

export const useTemplates = () => {
  // Use MV-based hook instead of TemplatesDataProvider
  const templatesData = useTemplatesForExperiments({
    pageSize: 50,
    enabled: true,
  });

  const getTemplate = useCallback(async templateId => {
    try {
      const data = await apiFetch(`/api/v1/templates/${templateId}?status=all`);
      return data;
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch template');
    }
  }, []);

  const getActiveTemplates = useCallback(() => {
    // Use MV-based hook method
    return templatesData.getActiveTemplates();
  }, [templatesData]);

  const getTemplatesForExperiment = useCallback(() => {
    // Use MV-based hook method
    return templatesData.getTemplatesForExperiment();
  }, [templatesData]);

  const getTemplateVersions = useCallback(async templateId => {
    if (!templateId) {
      return { templates: [] };
    }

    try {
      const data = await apiFetch(`/api/v1/templates/${templateId}/versions`);
      return data;
    } catch (err) {
      // If fetch fails, return empty array instead of crashing
      return { templates: [] };
    }
  }, []);

  const fetchTemplates = useCallback(
    async (params = {}) => {
      // Use MV-based hook method
      return templatesData.fetchTemplates(params);
    },
    [templatesData]
  );

  return {
    templates: templatesData.templates,
    loading: templatesData.loading,
    error: templatesData.error,
    fetchTemplates,
    getTemplate,
    getActiveTemplates,
    getTemplatesForExperiment,
    getTemplateVersions,
  };
};
